export enum MediaType {
  IMAGE = 'img',
  VIDEO = 'vid',
  GIF = 'gif',
}
